import { IFiltersState, PropertyType, Seller } from 'components/filters/types';
import config from 'config';
import { IAutocompleteEntry, CompletionType } from 'utils/entities';
import { BreakpointValue } from 'consts/breakpoints';
import { SearchViewMode } from 'components/list-view-switcher/constants';
import { SchoolLevel } from 'store/sagas/apiService/types';

export enum ComplexPropertyType {
  Projects = 'projects',
  VillaOrCottage = 'villaOrCottage',
  MultiplePropertyType = 'multiplePropertyType',
}

type HomeTypeKey = PropertyType | ComplexPropertyType | null;

export function getSingleSearchElementarySchoolDocId(resolvedAddresses: IAutocompleteEntry[]): string | null {
  if (resolvedAddresses && (resolvedAddresses.length === 1)) {
    const address = resolvedAddresses[0];
    if (address.type === CompletionType.SchoolDoc && address.schoolLevel === SchoolLevel.ELEMENTARY && address.docId) {
      return address.docId;
    }
  }
  return null;
}

export function getLeadingAgentsPositionByScreenRange(range: BreakpointValue, mode: SearchViewMode) {
  switch (mode) {
    case SearchViewMode.Grid: {
      switch (range) {
        case 1:
        case 2:
          return 7;
        case 3:
          return 13;
        default:
          return 17;
      }
    }
    case SearchViewMode.List: {
      switch (range) {
        case 1:
        case 2:
          return 7;
        default:
          return 9;
      }
    }
  }
}

export const getHomeTypeKey = (filters: IFiltersState, isCountrySearch: boolean): HomeTypeKey => {
  const { seller, propertyTypes } = filters;

  if (seller.length === 1 && seller[0] === Seller.Developer) {
    return ComplexPropertyType.Projects;
  }

  if (propertyTypes.length === 2 && propertyTypes[0] === PropertyType.PrivateHouse && propertyTypes[1] === PropertyType.Cottage) {
    return ComplexPropertyType.VillaOrCottage;
  }

  return propertyTypes.length === 1
    ? propertyTypes[0]
    : (!isCountrySearch && propertyTypes.length) ? ComplexPropertyType.MultiplePropertyType : null;
};

export function isDefaultSearch(resolvedAddresses: IAutocompleteEntry[]): boolean {
  if (resolvedAddresses && (resolvedAddresses.length === 1)) {
    return resolvedAddresses[0].docId === config.cityTerm;
  }
  return false;
}
